import styled from 'styled-components';
import { up } from 'styled-breakpoints';


const FormContainer = styled.div`
    border-radius: 15px;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.16);
    padding: 1.5em 2em;
    font-size: 0.9em;
    margin-bottom: 1em;

    ${up('sm')} {
        padding: 2em 3em;
        font-size: 0.95em;
    }

    ${up('lg')} {
        padding: 2.25em 3.5em;
        font-size: 1em;
    }

    ${up('xl')} {
        padding: 2.5em 4em;
    }

    ${up('xxl')} {
        padding: 3em 4em;
    }

    ${up('giant')} {
        padding: 4em;
    }

`;

export default FormContainer;